import {AfterViewInit, Component, OnInit} from '@angular/core';
import {language} from '../../../language/vn';


import {ThongBaoService} from '../../../service/info/service-thongbao';
import {ThongBaoFileService} from '../../../service/info/service-thongbaofile';
import {ThongBao} from '../../../models/info/thongbao';
import {environment} from '../../../../environments/environment';
import {Sessioncommand} from '../../../global/sessioncommand';
import {ReadThongBaoComponent} from './read.component';
import {BsModalService} from 'ngx-bootstrap/modal';
@Component({
  selector: 'ui-egov-hot-show',
  templateUrl: './hot.component.html'

})
export class HotThongBaoComponent implements OnInit, AfterViewInit {
  public language = language;
  public dataThongBao: ThongBao[] = [];
  public currentPage: number = 1;
  public maxSize: number = 10;
  public status: number[] =[   environment.chuaxuly  ];
  public xem: number = -1;
  constructor(  public thongBaoService: ThongBaoService,
                public bsModalService: BsModalService

  ) {
  }
  ngAfterViewInit() {
    this.thongBaoService.findAllByPaging('', Sessioncommand.staffId, -1,  this.currentPage, this.maxSize).subscribe(dataList => this.dataThongBao = dataList);
  }

  public thongBao(id: number) {
    const modalEdit = this.bsModalService.show(ReadThongBaoComponent, {class: 'modal-lg'});
    (<ReadThongBaoComponent>modalEdit.content).edit(
      id
    );
    (<ReadThongBaoComponent>modalEdit.content).onClose.subscribe(result => {

    });

  }
  ngOnInit(): void {
  }

}

